import http from "../../http"

const ipadmainService = {

    GetLastJrJson : async (KFZ,STD,JLVT) =>
    {
        const JRJsonData = await http.instance.get("/EffIpadPreview/GetLastJRjson/",{
            params :
                {
                    KFZ : KFZ,
                    STD : STD,
                    JLVT : JLVT
                }
        })
        return JRJsonData.data;
    },

    GetLastWrJson : async (KFZ,STD,WLVT) =>
    {
        const WRJsonData = await http.instance.get("/EffIpadPreview/GetLastWRjson/",{
            params :
                {
                    KFZ : KFZ,
                    STD : STD,
                    WLVT : WLVT
                }
        })
        return WRJsonData.data;
    },

    GetLastAttachmentJsonserv : async (LastKeyForNetline) =>
    {   //

        const AttachmentsJson = await http.instance.get("/EffIpadPreview/GetLastJsonAttachment/",{
            params :
                {
                    LastKeyForNetline : LastKeyForNetline
                }
        })
        return AttachmentsJson.data;
    },

    GetApiLastOCCSelfVersions_VS_IPADLastKnownVersions : async (KFZ) =>
    {

        //console.log("service GetApiLastOCCSelfVersions_VS_IPADLastKnownVersions : KFZ:"+KFZ);

        const LastOCCSelfVersions_VS_IPADLastKnownVersions = await http.instance.get("/EffIpadPreview/OCCSelfVersions_VS_IPADLastKnownVersions/",{
            params :
                {
                    KFZ : KFZ
                }
        })

        return LastOCCSelfVersions_VS_IPADLastKnownVersions.data;

    },

    // GetLastInputs : async (KFZ,STD,DeviceUID) =>
    // {
    //     const InputsJson = await http.instance.get("/EffIpadPreview/GetLastInputsJson/",{
    //       params :
    //           {
    //               STD : STD,
    //               KFZ : KFZ,
    //               DeviceUID: DeviceUID
    //           }
    //     })
    //     return InputsJson;
    // },


    // GetLastFiles : async (KFZ,STD,DeviceUID) =>
    // {
    //
    //     const InputsJson = await http.instance.get("/EffIpadPreview/GetLastFilesJson/",{
    //         params :
    //             {
    //                 STD : STD,
    //                 KFZ : KFZ,
    //                 DeviceUID : DeviceUID
    //             }
    //     })
    //
    //     return InputsJson;
    // },


    GetCombinedJsons : async (KFZ, STD, JLVT, WLVT,DeviceUID) =>
    {
        const AllJson = await http.instance.get("/EffIpadPreview/GetCombinedjson/",{
            params :
                {
                    KFZ : KFZ,
                    STD : STD,
                    JLVT : JLVT,
                    WLVT : WLVT,
                    DeviceUID: DeviceUID
                }
        })

        return AllJson;
    }


};

export default ipadmainService;
